export default {"src":"/_next/static/media/logo.b80b7b6e.svg","height":239,"width":239};